import React, { useMemo } from 'react';
import { DocContent } from '../models/types';
import { Breadcrumbs } from './Breadcrumbs';
import { renderMarkdownSafe } from '../services/markdownSafe';

interface Props {
  doc?: DocContent;
}

export const DocsContent = ({ doc }: Props): JSX.Element => {
  const html = useMemo(() => (doc ? renderMarkdownSafe(doc.content) : ''), [doc]);

  if (!doc) {
    return (
      <div className="docs-content">
        <p className="muted">Select a document from the tree to view content.</p>
      </div>
    );
  }

  return (
    <div className="docs-content">
      <Breadcrumbs
        trail={[
          { label: doc.category },
          { label: doc.path }
        ]}
      />
      <h3 style={{ marginTop: '8px' }}>{doc.title}</h3>
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
};
